import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import {RouteStack} from '../route-stack.model';

export const ADD_Route = '[RouteStack] Add';
export const REMOVE_Route = '[RouteStack] Remove';
export const GET_ROUTE = '[RouteStack] GET_RouteStack';
export const UNHANDLED_ROUTE = '[RouteStack] UNHANDLED_ROUTE';
export const ADD_PAYMENT_OBJ = '[RouteStack] ADD_PAYMENT_OBJ';
export const REMOVE_PAYMENT_OBJ = '[RouteStack] REMOVE_PAYMENT_OBJ';
export const CHANGE_WAITING_PAYMENT_STATUS = '[RouteStack] CHANGE_WAITING_PAYMENT_STATUS';

export class GetRoute implements Action {
  readonly type = GET_ROUTE;

  constructor() { }
}

export class ADDRoute implements Action {
  readonly type = ADD_Route;

  constructor(public payload: RouteStack) {}
}

export class RemoveRoute implements Action {
  readonly type = REMOVE_Route;
}

export class UnhandledRoute implements Action {
  readonly type = UNHANDLED_ROUTE;
}

export class ADDPaymenObj implements Action {
  readonly type = ADD_PAYMENT_OBJ;

  constructor(public payload: any) {}
}

export class RemovePaymentObj implements Action {
  readonly type = REMOVE_PAYMENT_OBJ;
}

export class ChangeWaitingPaymentStatus implements Action {
  readonly type = CHANGE_WAITING_PAYMENT_STATUS;

  constructor(public payload: boolean) {}
}

export type Actions = ADDRoute | RemoveRoute | GetRoute | UnhandledRoute | ADDPaymenObj | RemovePaymentObj | ChangeWaitingPaymentStatus;

